// Impresión de documentos (recibos, liquidaciones, reportes, slips, estados de cuenta…) y
// escape de HTML. UN solo lugar para las dos cosas.
//
// SEGURIDAD (revisión 2026-10-03): los documentos se arman con datos que escriben los
// usuarios (nombres de clientes, beneficiarios, notas). Antes se escribían en un iframe del
// MISMO origen sin aislar, o en una ventana nueva: un texto como `<img src=x onerror=…>`
// en el nombre de un cliente se EJECUTABA al imprimir y podía robar la sesión del master.
// Ahora el iframe va con `sandbox` SIN `allow-scripts`: el documento se ve y se imprime
// igual, pero el navegador no ejecuta nada de lo que venga dentro. Por eso los documentos
// no deben traer <script>: la impresión la dispara esta función, desde afuera.

// Escapa un valor para meterlo en HTML como TEXTO (no como etiquetas).
export function escHtml(v) {
  return String(v ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// Imprime un HTML completo en un iframe oculto y aislado (no depende de ventanas emergentes).
// `alFallar(mensaje)` es opcional; por defecto, un alert con el motivo.
export function imprimirHTML(html, alFallar) {
  const avisar = alFallar || ((m) => alert(m));
  const iframe = document.createElement('iframe');
  // allow-same-origin: para poder escribir el documento desde aquí. allow-modals: para que
  // el diálogo de impresión se abra. SIN allow-scripts: nada de lo escrito se ejecuta.
  iframe.setAttribute('sandbox', 'allow-same-origin allow-modals');
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(String(html).replace(/<script\b[\s\S]*?<\/script>/gi, ''));
  doc.close();
  setTimeout(() => {
    try { iframe.contentWindow.focus(); iframe.contentWindow.print(); }
    catch (e) { avisar('No se pudo imprimir: ' + (e.message || '')); }
    setTimeout(() => { try { document.body.removeChild(iframe); } catch { /* ya no está */ } }, 2000);
  }, 400);
}
